import { createStructureStatementHandler } from '../../createStructureStatementHandler';
export const defineRedirectOnPersistEventStmtInstruction = `
#### Defining Redirect on persist event

- Syntax: \`define redirect_on_persist <event_name> on <source_view>.<source_scope> to <target_view>;\`
- Example: \`define redirect_on_persist ProductRedirectOnSuccess on ProductCreate.ProductScope to ProductDetail;\`
`;
export const stmtDefineRedirectOnPersistEvent = (stmt) => {
    if (!stmt.sourceScopeName) {
        return `define redirect_on_persist ${stmt.eventName} on ${stmt.sourceViewName} to ${stmt.targetViewName};`;
    }
    return `define redirect_on_persist ${stmt.eventName} on ${stmt.sourceViewName}.${stmt.sourceScopeName} to ${stmt.targetViewName};`;
};
// define redirect_on_persist BookRedirectOnSuccess on BookEdit.Book to BookDetail;
export const defineRedirectOnPersistEventHandler = createStructureStatementHandler({
    type: 'define redirect_on_persist',
    parse: line => {
        const match = /^define redirect_on_persist (?<eventName>\w+) on (?<sourceViewName>\w+)(\.(?<sourceScopeName>\w+))?( to (?<targetViewName>\w+))?/.exec(line);
        return match?.groups
            ? {
                type: 'define redirect_on_persist',
                eventName: match.groups.eventName,
                sourceViewName: match.groups.sourceViewName,
                sourceScopeName: match.groups.sourceScopeName,
                targetViewName: match.groups.targetViewName,
            }
            : null;
    },
    apply: (stmt, builder) => {
        builder.updateStructure(it => it.addEvent({
            eventName: stmt.eventName,
            sourceViewName: stmt.sourceViewName,
            sourceScopeName: stmt.sourceScopeName,
            eventType: 'redirectOnPersist',
            targetViewName: stmt.targetViewName,
        }));
    },
});
//# sourceMappingURL=DefineRedirectOnPersistEvent.js.map